<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout search-area">
      <!-- 기부자 검색 -->

      <div id="scrollDonorList"></div>
      <scha-donor-list-comp
        @updateSum="onUpdateSum"
        @returnResult="onClickDonorList"
        @returnQueryResult="callbackQuery"
        @returnPagingResult="callbackPaging"
        @resetView="resetView"
        ref="schaDonorList"
      >
        <div slot="bottomRightArea">
          <md-card-actions md-alignment="right">
            <div>
              <md-button class="md-info md-sm" @click="addDonor">
                <md-icon>check</md-icon>신규 등록
              </md-button>
            </div>
          </md-card-actions>
        </div>
      </scha-donor-list-comp>

      <!-- 기부자 상세 -->
       <div style="display: flex;">
        
        <div id="scrollTargetBox"></div>

        <donator-edit-comp
          ref="donatorEdit"
          @onDonorSave="onDonorSave"
          @onClickDonorList="onClickDonorList"
          @onClickTab="onClickTab"
          @openPrintableDonator="openPrintableDonator"
          @addDonor="addDonor"
          :mapping-cnt.sync="mappingCnt"
          v-show="this.selectedDonator !== null || this.isAddDonor"
        ></donator-edit-comp>

        <!-- <DonatorContactHisComp
          ref="donatorContactHis"
          @onClickDonorList="onClickDonorList"
          v-show="this.selectedDonator !== null || this.isAddDonor"
          :donator="selectedDonator" style="width: 300px; margin-left: 10px;"
        /> -->
        </div>

      <md-card v-show="selectedDonator !== null && !isAddDonor">
        <md-card-header md-alignment="space-between">
          <h4 class="title"><md-icon>assignment</md-icon>조회 결과</h4>
        </md-card-header>
        <div class="md-group tab-area">
          <md-button class="md-default2" @click="onClickTab(1, null, true)"
            >장학생 매칭</md-button
          >
          <md-button class="md-default2" @click="onClickTab(2, null, true)"
            >기부액</md-button
          >
          <md-button class="md-default2" @click="onClickTab(3, null, true)"
            >지급명단</md-button
          >
          <md-button class="md-default2" @click="onClickTab(4, null, true)"
            >지급특성</md-button
          >
          <md-button class="md-default2" @click="onClickTab(5, null, true)"
            >추천관계자</md-button
          >
          <md-button class="md-default2" @click="onClickTab(6, null, true)"
            >재학중 수혜내역</md-button
          >
          <md-button class="md-default2" @click="onClickTab(7, null, true)"
            >학기별 약정내역</md-button
          >
          <md-button class="md-default2" @click="onClickTab(8, null, true)"
            >담당자</md-button
          >
          <md-button class="md-default2" @click="onClickTab(9, null, true)"
            >주요변동사항</md-button
          >
          <!-- <h4 style="margin-left: 100px;">
          약정금액 합계 : {{ sumData.totalAgreemAmount.toLocaleString() }}원 |
           실입금액 합계 : {{ sumData.totalRealAmount.toLocaleString() }}원 |
            기부금(기본재산) 합계 : {{ sumData.totalFundAmount.toLocaleString() }}원
          </h4> -->
        </div>
        <!-- 탭 영역 -->
        <schaDonor-tab-list-comp
          :tab-index.sync="currentTab"
          ref="SchaDonorTabList"
        ></schaDonor-tab-list-comp>
        <schaDonor-tab1-list-comp
          :tab-index.sync="currentTab"
          ref="SchaDonorTab1List"
          @buttonClick="buttonClick"
          @queryCnt="queryCnt"
          :sum-data="sumData"
        ></schaDonor-tab1-list-comp>
        <schaDonor-tab9-list-comp
          :tab-index.sync="currentTab"
          ref="SchaDonorTab9List"
        ></schaDonor-tab9-list-comp>
      </md-card>
    </div>
    <!--장학매칭 팝업 -->
    <donor-matching-modal-comp
      :is-show.sync="isShowUserModal"
      @saveComplete="matchingComplete"
      ref="DonorMatchingModal"
    ></donor-matching-modal-comp>

    <!-- 기부자 카드 출력 -->
    <PrintableDonator
      :isShow.sync="showPrintableDonator"
      :printData="printableDonatorData"
    />
  </div>

  
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import URL_CONST from "@/kuaa/kuaa-url-const";
import DonatorEditComp from "@/pages/Scholarship/Components/DonatorEditComp";
import SchaDonorListComp from "@/pages/Scholarship/Components/SchaDonorListComp";
import SchaDonorTab1ListComp from "@/pages/Scholarship/Components/SchaDonorTab1ListComp";
import SchaDonorTab9ListComp from "@/pages/Scholarship/Components/SchaDonorTab9ListComp"
import SchaDonorTabListComp from "@/pages/Scholarship/Components/SchaDonorTabListComp";
import DonorMatchingModalComp from "@/pages/Scholarship/Components/DonorMatchingModalComp";
import PrintableDonator from "@/pages/Scholarship/Components/PrintableDonator.vue";
import DonatorContactHisComp from "@/pages/Scholarship/Components/DonatorContacHisComp.vue";
import { sum } from "lodash";



export default {
  components: {
    SchaDonorListComp,
    DonatorEditComp,
    SchaDonorTab1ListComp,
    SchaDonorTab9ListComp,
    SchaDonorTabListComp,
    DonorMatchingModalComp,
    PrintableDonator
    , DonatorContactHisComp
  },
  data() {
    return {
      isShowUserModal: false,
      currentTab: 1,
      selectedDonator: null,
      memberNo: null,
      searchQuery: null,
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
      isDeleteWrk: false,
      isAddDonor: false,
      //기부자에 매핑된 학생수
      mappingCnt: 0,
      sumData: {
        totalAgreemAmount: 0,
        totalRealAmount: 0,
        totalFundAmount: 0
      },
      showPrintableDonator: false,
      printableDonatorData: {}
    };
  },
  computed: {
    editSemesterCd() {
      return this.$refs.donatorEdit.query.semesterCd;
    }
  },
  methods: {
    onUpdateSum(sum) {
      this.sumData = sum;
    },
    
    openPrintableDonator(donatorInfo) {
      console.log("openPrintableDonator", donatorInfo);
      this.printableDonatorData = donatorInfo;
      this.showPrintableDonator = true;
    },

    getDonorList() {
      if (this.isDeleteWrk) {
        kuaaFnc.scrollTo("scrollDonorList");
        this.isDeleteWrk = false;
        this.$refs.schaDonorList.sendQuery(true);
      } else if (this.selectedDonator || this.isAddDonor) {
        this.$refs.schaDonorList.sendQuery(false);
        this.onClickTab(1, null);
      } else {
        this.$refs.schaDonorList.sendQuery(true);
      }
    },

    resetView() {
      this.selectedDonator = null;
      this.isDeleteWrk = false;
      this.isAddDonor = false;
      this.$refs.SchaDonorTab1List.girdClear();
      this.onClickTab(null, null);

      //kuaaFnc.scrollTo('scrollDonorList');
    },
    onClickDonorList(item, sumData) {
    this.isDeleteWrk = false;
    this.isAddDonor = false;
    this.selectedDonator = item;
    this.$refs.donatorEdit.setQuery(item);
    this.onClickTab(item ? 1 : null, item);
    console.log("onClickDonorList", item, sumData);
    //kuaaFnc.scrollTo('scrollTargetBox');
  },
    onClickTab(index, item, isTabClick) {
      if (!index) {
        //kuaaFnc.scrollTo('scrollTargetBox');
        return false;
      }

      if (index) {
        this.currentTab = index;
      }
      if (item && item.memberNo) {
        this.memberNo = item.memberNo;
      }
      switch (this.currentTab) {
        case 1:
          this.$refs.DonorMatchingModal.currentSemesterCd = this.editSemesterCd;
          this.$refs.DonorMatchingModal.currentMemberNo = this.memberNo;
          this.$refs.SchaDonorTab1List.sendQuery(
            this.currentTab,
            this.memberNo,
            this.editSemesterCd
          );
          if (!isTabClick) kuaaFnc.scrollTo("scrollTargetBox");
          break;
        case 3:
          this.$refs.SchaDonorTab1List.sendQuery(
            this.currentTab,
            this.memberNo
          );
          if (!isTabClick) kuaaFnc.scrollTo("scrollTargetBox");
          break;
        case 6:
          this.$refs.SchaDonorTab1List.sendQuery(
            this.currentTab,
            this.memberNo
          );
          if (!isTabClick) kuaaFnc.scrollTo("scrollTargetBox");
          break;
        case 9:
        if (this.$refs.SchaDonorTab9List && this.$refs.SchaDonorTab9List.sendQuery) {
          this.$refs.SchaDonorTab9List.sendQuery(
            this.currentTab,
            this.memberNo
          );
        }
        if (!isTabClick) kuaaFnc.scrollTo("scrollTargetBox");
        break;
        default:
          this.$refs.SchaDonorTabList.sendQuery(this.currentTab, this.memberNo);
          if (!isTabClick) kuaaFnc.scrollTo("scrollTargetBox");
          break;
      }
    },

    // 장학생 매칭 버튼 클릭
    buttonClick(item) {
      if (!this.selectedDonator) {
        kuaaFnc.showSwal("장학생 매칭", `매칭할 교우를 먼저 선택해 주세요`);
      } else {
        this.isShowUserModal = true;
        // giveAmount 가져와야 함
        this.$refs.DonorMatchingModal.setData(item, this.selectedDonator);
      }
    },

    queryCnt(cnt) {
      if (this.selectedDonator) {
        this.mappingCnt = cnt;
      }
    },

    addDonor() {
      this.selectedDonator = null;
      this.isAddDonor = true;
      this.$refs.donatorEdit.setQuery(null);
      kuaaFnc.scrollTo("scrollTargetBox");
    },

    matchingComplete() {
      this.$refs.SchaDonorTab1List.sendQuery(
        1,
        this.memberNo,
        this.editSemesterCd
      );
    },

    callbackQuery(result) {
      this.searchQuery = result;
    },

    callbackPaging(result) {
      this.pagination = result;
    },

    onDonorSave(isDelete, isNew) {
      if (isDelete || isNew) {
        this.isDeleteWrk = true;
        this.selectedDonator = null;
      }
      this.$refs.SchaDonorTab1List.amountTot = "0";
      this.getDonorList();
    },

    downloadExcel() {
      this.searchQuery.page = 1;
      this.searchQuery.perPage = this.pagination.total;
      this.searchQuery.fileName = "기부자 관리";
      kuaaApi.requestFileDownload(
        URL_CONST.SCHA_APPLY_DONOR_EXCEL_DOWNLOAD,
        this.searchQuery,
        "기부자 관리.xlsx",
        response => {}
      );
    }
  }
};
</script>

<style></style>
